export default __webpack_public_path__ + "static/media/edit.2655a9f7.svg";